// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__ork8C","head":"styles_head__MilEV","text":"styles_text__lzXAW"};